import { useEffect, useRef, useState } from 'react';
import styles from './chips.module.scss';
import { IconButton } from '@mui/material';
import { capitalize } from '../../../../../helpers/app';
import { images } from '../../../../../constants/images';
import { ChipsMyPublicationsProps } from '../../../../../interfaces/components';

const Chips = ({ 
    filters,
    setStatesMyPublications,
    setBranchesMyPublications,
    setYearsMyPublications,
    setSellersMyPublications,
    setSearchMyPublications
 }: ChipsMyPublicationsProps) => {
    const chipsRef: any = useRef(null);
    const chipsContainerRef: any = useRef(null);

    const deleteFilter = (type: any, filter?: any, ) => {
        if(type === "text"){
            setSearchMyPublications("");
        }
        if(type === "states"){
            const statesFiltered = filters?.states.filter((item: any) => item?.id !== filter?.id);
            setStatesMyPublications(statesFiltered);
        }
        if(type === "branches"){
            const branchesFiltered = filters?.branches.filter((item: any) => item?.id !== filter?.id);
            setBranchesMyPublications(branchesFiltered);
        }
        if(type === "years"){
            const yearsFiltered = filters?.years.filter((item: any) => item?.name !== filter?.name);
            setYearsMyPublications(yearsFiltered);
        }
        if(type === "sellers"){
            const sellersFiltered = filters?.sellers.filter((item: any) => item?.id !== filter?.id);
            setSellersMyPublications(sellersFiltered);
        }
    }

    return (
        <>
        {
            (!!filters.text.length || !!filters.states.length || !!filters.branches.length || !!filters.years.length || !!filters.sellers.length) &&
            <div className={styles.chips} ref={chipsRef}>
                <div className={styles.chipsContainer} ref={chipsContainerRef}>
                    {
                        filters.text.length > 0 &&
                        <div className={styles.chip} onClick={() => deleteFilter('text')}>
                            <p>{capitalize(filters.text)}</p>
                            <IconButton className={styles.icon} aria-label='Filtro'>
                                <img src={images.close} alt="Eliminar" />
                            </IconButton>
                        </div>
                    }
                    {
                        filters.states.map((item: any) => (
                            <div className={styles.chip} onClick={() => deleteFilter('states', item)}>
                                <p>{capitalize(item?.name)}</p>
                                <IconButton className={styles.icon} aria-label='Filtro'>
                                    <img src={images.close} alt="Eliminar" />
                                </IconButton>
                            </div>
                        ))
                    }
                    {
                        filters.branches.map((item: any) => (
                            <div className={styles.chip} onClick={() => deleteFilter('branches', item)}>
                                <p>{capitalize(item?.name)}</p>
                                <IconButton className={styles.icon} aria-label='Filtro'>
                                    <img src={images.close} alt="Eliminar" />
                                </IconButton>
                            </div>
                        ))
                    }
                    {
                        filters.years.map((item: any) => (
                            <div className={styles.chip} onClick={() => deleteFilter('years', item)}>
                                <p>{capitalize(item?.name.toString())}</p>
                                <IconButton className={styles.icon} aria-label='Filtro'>
                                    <img src={images.close} alt="Eliminar" />
                                </IconButton>
                            </div>
                        ))
                    }
                    {
                        filters.sellers.map((item: any) => (
                            <div className={styles.chip} onClick={() => deleteFilter('sellers', item)}>
                                <p>{capitalize(item?.name)}</p>
                                <IconButton className={styles.icon} aria-label='Filtro'>
                                    <img src={images.close} alt="Eliminar" />
                                </IconButton>
                            </div>
                        ))
                    }
                </div>
            </div>
        }
        </>
    )
};
export default Chips;